// extracted by mini-css-extract-plugin
module.exports = {"header":"SkillHeader_header__2fnwJ","participantheader":"SkillHeader_participantheader__1zYZU SkillHeader_header__2fnwJ","backbutton":"SkillHeader_backbutton__1f2mh"};